/**
 * 导出用户正在使用的路由表
 * 用户登录后，将会把正在使用的路由表备份到这里
 */
export default {
    current: []
}